// Module
var code = "<div id=\"main\"> <router-view/> </div> ";
// Exports
module.exports = code;